var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstallationsEmptyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4.54v8.26c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C29.52 16 30.08 16 31.2 16h8.261M28 34H16m16-8H16m24-6.024V34.4c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C35.44 44 33.76 44 30.4 44H17.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C8 39.44 8 37.76 8 34.4V13.6c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C12.56 4 14.24 4 17.6 4h6.424c1.467 0 2.2 0 2.891.166a6 6 0 0 1 1.735.718c.605.371 1.124.89 2.162 1.928l6.376 6.376c1.038 1.038 1.557 1.557 1.928 2.162a6 6 0 0 1 .718 1.735c.166.69.166 1.424.166 2.891z",
    stroke: "#76BC21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallationsEmptyIcon);
export default __webpack_public_path__ + "static/media/installations_empty_icon.1ff147d45607b2c77433c5eda0f39e1e.svg";
export { ForwardRef as ReactComponent };